export enum PinCreationState {
  Idle = 'Idle', // When not in creation mode
  EnterCreationMode = 'EnterCreationMode', // Step 1: Entering creation mode, hiding existing pins, disabling some events
  WaitForPlanSelection = 'WaitForPlanSelection', // Waiting for plan to be selected before entering creation mode
  ObjectSelected = 'ObjectSelected',    // Step 2: User clicked on an object, pins appear on Leaflet and Forge Viewer
  PrepareSave = 'PrepareSave'     // Step 3: Preparing pins for save, user selects area for screenshot
}
